module.exports = __webpack_public_path__ + "img/checkmark.581a4f4a.png";